// Limits enforced by the backend for photos sent with a clock report or a clock request.
export const MAX_PHOTOS = 3;
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

const SHRINK_ABOVE_BYTES = 1024 * 1024;
const MAX_DIMENSION = 1600;


export async function preparePhoto(file) {
  const canShrink = PHOTO_TYPES.includes(file.type)
    && file.size > SHRINK_ABOVE_BYTES
    && typeof createImageBitmap === 'function'
    && typeof document !== 'undefined';
  if (!canShrink) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    if (bitmap.close) bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.85));
    if (blob && blob.size < file.size) {
      return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
    }
  } catch (e) {
    // fall through to the original file
  }
  return file;
}


export function photoProblem(file) {
  if (!PHOTO_TYPES.includes(file.type)) {
    return `${file.name} is not a JPEG, PNG or WebP image.`;
  }
  if (file.size > MAX_PHOTO_BYTES) {
    return `${file.name} is larger than ${MAX_PHOTO_BYTES / (1024 * 1024)}MB.`;
  }
  return null;
}
